import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.DeliverAllTasksModal.title',
    defaultMessage: 'Deliver all tasks',
  },
  success: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.DeliverAllTasksModal.success',
    defaultMessage: 'All tasks delivered',
  },
  warning: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.DeliverAllTasksModal.warning',
    defaultMessage: 'This is non-reversible, and will affect ALL tasks.',
  },
  textAreaLabel: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.DeliverAllTasksModal.textAreaLabel',
    defaultMessage: 'Customer note',
  },
  deliver: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.DeliverAllTasksModal.deliver',
    defaultMessage: 'Deliver all tasks',
  },
  delivering: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.DeliverAllTasksModal.delivering',
    defaultMessage: 'Delivering...',
  }
})
